<template>
    <div class="bg">
            <h1>Sorry. You cant go there...</h1>
    <img src="https://s3.amazonaws.com/wageup-media/permission_denied.jpg"/>
        <a href="https://www.freepik.com/free-photos-vectors/background">Background vector created by freepik - www.freepik.com</a>
        </div>
</template>

<script>
    export default {
        name: "403"
    }
</script>

<style lang="less" scoped>

.bg {
  /* The image used */
  background-image: url("https://s3.amazonaws.com/wageup-media/permission_denied.jpg");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
